// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".required[data-v-5307fcbe]:after{color:var(--primary);content:\" *\"}", "",{"version":3,"sources":["webpack://./resources/js/Atoms/FormLabel.vue"],"names":[],"mappings":"AACA,iCAEE,oBAAA,CADA,YACF","sourcesContent":["\n.required::after {\n  content: ' *';\n  color: var(--primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
